<template>
  <v-form>
    <v-row>
      <div class="inputSearch">
        <v-row>
          <v-col cols="12" md="4" lg="4">
            <v-text-field v-model="titleHeadFeeFilter" v-bind:label="$route.meta.title" hide-details outlined required
              dense></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" v-if="(router === 'priority' && !isSubFee) || isSubFee">
            <v-autocomplete v-model="headFee" clear-icon="mdi-close" :items="headFees" item-text="title" item-value="id"
              label="Áp dụng với khoản phí thu/đóng" clearable outlined dense hide-details return-object>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" v-if="!isSubFee">
            <v-autocomplete v-model="categoryHeadFeeFilter" clear-icon="mdi-close" :items="categoryHeadFee"
              item-text="category" item-value="id" label="Phân loại" clearable outlined dense hide-details
              return-object>
            </v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <div class="buttonSearch ml-6">
        <div class="d-flex flex-column justify-start">
          <v-btn class="search-button" @click="onFilterChange" outlined>
            Tìm kiếm
          </v-btn>
        </div>
      </div>
    </v-row>
  </v-form>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  data: () => ({
    titleHeadFeeFilter: null,
    categoryHeadFeeFilter: null,
    categoryHeadFee: ['Mặc định', 'Bổ sung'],
    headFee: '',
    headFees: []
  }),
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'oneHeadFee', 'isSubFee'])
  },
  async created() {
    this.headFees = await this.fetchHeadFees({ type: 'normal', isSubFee: 'false' })
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['filterheadFee', 'fetchHeadFees']),
    onFilterChange() {
      const filterType =
        this.categoryHeadFeeFilter === 'Mặc định' ? 'default' : this.categoryHeadFeeFilter === 'Bổ sung' ? 'custom' : ''
      let payload = {
        tags_contains:
          this.titleHeadFeeFilter && this.titleHeadFeeFilter.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        category: filterType,
        type: this.router,
        isSubFee: this.isSubFee,
        head_fee_apply: this.headFee && this.headFee.id
      }
      this.filterheadFee(payload)
    },
    addHeadFeeSuccess() {
      switch (this.router) {
        case 'normal':
          this.titleHeadFeeFilter = this.oneHeadFee.tags
          break
        case 'priority':
          this.titleHeadFeeFilter = this.oneHeadFee.tags
          this.headFee = this.oneHeadFee.head_fee_apply
          break
      }
    }
  },
  watch: {
    async router() {
      if ((this.router === 'priority' && !this.isSubFee) || this.isSubFee) {
        this.headFees = await this.fetchHeadFees({ type: 'normal', isSubFee: 'false' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
div.buttonSearch {
  width: 106px;
}

div.inputSearch {
  width: calc(100% - 120px - 12px);
}

@media screen and (max-width: 960px) {
  div.buttonSearch {
    width: 110px;
    padding-top: 24px;
    margin-left: 0px !important;
  }

  div.inputSearch {
    width: 100%;
  }
}
</style>
